<div [formGroup]="contactsForm" appAutoAudit [auditData]="fieldAuditData" [auditDisabled]="!!snapshotData">
  <div class="form-title-container is-fullwidth">
    <h3>Personas de contacto</h3>
    <a class="button add-button" (click)="openContactModal()"
      >Añadir contacto</a
    >
  </div>
  <div class="card">
    <app-clients-table
      [configTable]="activeContactsTableConfig"
      [snapshotMode]="!!snapshotData"
      (openItemEvent)="openContactModal($event)"
      (deleteItemEvent)="openDeleteContactModal($event)"
    >
    </app-clients-table>
  </div>

  <div class="modal" [ngClass]="{ 'is-active': isContactModalVisible }">
    <div class="modal-background" (click)="closeContactModal()"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">
          {{
            editingContactIndex !== undefined
              ? "Editar contacto"
              : "Nuevo contacto"
          }}
        </p>
        <button
          class="delete"
          aria-label="close"
          (click)="closeContactModal()"
        ></button>
      </header>
      <form [formGroup]="contactForm" (submit)="saveContact()">
        <section
          class="modal-card-body"
          style="max-height: 70vh; overflow-y: auto"
        >
          <div class="columns is-multiline">
            <div class="column is-12 form-container">
              <span class="label">Nombre completo</span>
              <input
                class="search-input"
                type="text"
                pInputText
                formControlName="name"
                style="text-transform: uppercase"
              />
            </div>
            <div class="column is-12 form-container">
              <div class="field">
                <p-checkbox
                  formControlName="isMainContact"
                  [binary]="true"
                  inputId="mainContact"
                >
                </p-checkbox>
                <label
                  for="mainContact"
                  style="margin-left: 0.5rem; cursor: pointer"
                  >Contacto principal</label
                >
              </div>
            </div>
            <div class="column is-12 form-container">
              <span class="label">Idioma de contacto</span>
              <input
                class="search-input"
                type="text"
                pInputText
                formControlName="language"
              />
            </div>
            <div class="column is-12 form-container">
              <span class="label">Número de teléfono</span>
              <div formArrayName="phones">
                <div
                  *ngFor="let phone of phones.controls; let i = index"
                  class="columns is-mobile"
                  style="margin-bottom: 0.5rem; align-items: center"
                >
                  <div class="column" style="display:flex; align-items:center; gap:0.4rem">
                    <input
                      class="search-input"
                      type="text"
                      pInputText
                      [formControlName]="i"
                      placeholder="Número de teléfono"
                    />
                  </div>
                  <div class="column is-narrow">
                    <a
                      class="close-button"
                      (click)="removePhone(i)"
                      title="Eliminar"
                    >
                      <fa-icon
                        [icon]="faTrash"
                        [ngStyle]="{ cursor: 'pointer' }"
                      ></fa-icon>
                    </a>
                  </div>
                </div>
                <button
                  type="button"
                  class="button add-button"
                  (click)="addPhone()"
                >
                  + Añadir teléfono
                </button>
              </div>
            </div>
            <div class="column is-12 form-container">
              <span class="label">Correo electrónico</span>
              <div formArrayName="departments">
                <div
                  *ngFor="let dep of departments.controls; let i = index"
                  [formGroupName]="i"
                  class="columns is-multiline"
                  style="margin-bottom: 1rem"
                >
                  <div class="column is-4">
                    <input
                      type="text"
                      pInputText
                      formControlName="department"
                      placeholder="Departamento"
                      class="search-input"
                    />
                  </div>
                  <div class="column is-7">
                    <input
                      class="search-input"
                      type="text"
                      pInputText
                      formControlName="mail"
                      placeholder="Correo electrónico"
                    />
                  </div>
                  <div class="column is-1">
                    <a
                      class="close-button"
                      (click)="removeDepartment(i)"
                      title="Eliminar"
                    >
                      <fa-icon
                        [icon]="faTrash"
                        [ngStyle]="{ cursor: 'pointer' }"
                      ></fa-icon>
                    </a>
                  </div>
                </div>
                <button
                  type="button"
                  class="button add-button"
                  (click)="addDepartment()"
                >
                  + Añadir correo
                </button>
              </div>
            </div>
            <div class="column is-12 form-container">
              <span class="label">Observaciones</span>
              <textarea
                class="search-input observations-field"
                pInputTextarea
                [autoResize]="true"
                formControlName="observations"
                rows="3"
                maxlength="2000"
              ></textarea>
            </div>
          </div>
        </section>
        @if (submitError) {
          <p class="help is-danger" style="padding: 0 24px 12px;">{{ submitError }}</p>
        }
        <footer class="modal-card-foot buttons-container">
          <ng-container *ngIf="snapshotData; else contactEditButtons">
            <button type="button" class="button cancel-button" (click)="closeContactModal()">Cerrar</button>
          </ng-container>
          <ng-template #contactEditButtons>
            <button class="button cancel-button" (click)="closeContactModal()">
              Cancelar
            </button>
            <button
              class="button save-button"
              type="submit"
              [disabled]="!contactForm.valid"
            >
              Guardar
            </button>
          </ng-template>
        </footer>
      </form>
    </div>
  </div>

  <div class="delete-modal" [class.is-active]="isDeleteContactModalVisible">
    <div
      class="delete-modal-background"
      (click)="closeDeleteContactModal()"
    ></div>
    <div class="delete-modal-content">
      <h1 class="delete-modal-title">Eliminar persona de contacto</h1>
      <div class="delete-modal-body">
        <div class="column is-12">
          <span>
            ¿Está seguro/a que desea eliminar la persona de contacto?
          </span>
        </div>
        @if (submitError) {
          <p class="help is-danger" style="padding: 0 24px 12px;">{{ submitError }}</p>
        }
        <div class="delete-modal-buttons">
          <button
            class="button is-outlined cancel-button"
            (click)="closeDeleteContactModal()"
          >
            Cancelar
          </button>
          <button
            class="comment-button button is-pulled-right"
            (click)="confirmDeleteContact()"
          >
            Aceptar
          </button>
        </div>
      </div>
    </div>
  </div>

  <div
    class="form-title-container is-fullwidth"
    [ngStyle]="{ 'margin-top': '40px' }"
  >
    <h3>Usuarios</h3>
    <a class="button add-button" (click)="openUserModal()">Añadir usuario</a>
  </div>
  <div class="card">
    <app-clients-table
      [configTable]="activeUsersTableConfig"
      [snapshotMode]="!!snapshotData"
      (openItemEvent)="openUserModal($event)"
      (deleteItemEvent)="openDeleteUserModal($event)"
    >
    </app-clients-table>
  </div>
  <!-- Modal para crear/editar usuario -->
  <div class="modal" [ngClass]="{ 'is-active': isUserModalVisible }">
    <div class="modal-background" (click)="closeUserModal()"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">
          {{
            editingUserIndex !== undefined ? "Editar usuario" : "Nuevo usuario"
          }}
        </p>
        <button
          class="delete"
          aria-label="close"
          (click)="closeUserModal()"
        ></button>
      </header>
      <form [formGroup]="userForm" (submit)="saveUser()">
        <section
          class="modal-card-body"
          style="max-height: 60vh; overflow-y: auto"
        >
          <div class="columns is-multiline">
            <div class="column is-12 form-container">
              <span class="label">Contacto</span>
              <p-dropdown
                formControlName="contact"
                [options]="configContactsTable.data"
                [showClear]="true"
                optionLabel="name"
                optionValue="id"
                [placeholder]="'Sin contacto asociado'"
                appendTo="body"
              >
              </p-dropdown>
            </div>
            <div class="column is-12 form-container">
              <span class="label">Usuario</span>
              <input
                class="search-input"
                type="text"
                pInputText
                formControlName="username"
              />
            </div>
            <div class="column is-12 form-container">
              <span class="label">Contraseña</span>
              <div
                style="position: relative; display: flex; align-items: center"
              >
                <input
                  class="search-input"
                  [type]="showPassword ? 'text' : 'password'"
                  pInputText
                  formControlName="password"
                  style="padding-right: 2.5rem"
                />
                <button
                  type="button"
                  (click)="showPassword = !showPassword"
                  style="
                    position: absolute;
                    right: 1rem;
                    background: none;
                    border: none;
                    cursor: pointer;
                    outline: none;
                  "
                  tabindex="-1"
                >
                  <fa-icon [icon]="showPassword ? faEyeSlash : faEye"></fa-icon>
                </button>
              </div>
            </div>
            <div class="column is-12 form-container">
              <span class="label">Correo electrónico</span>
              <p-dropdown
                [options]="availableEmails"
                optionLabel="label"
                optionValue="value"
                [filter]="true"
                placeholder="Seleccionar correo electrónico"
                formControlName="mail"
                [emptyFilterMessage]="'No hay correos disponibles'"
                appendTo="body"
              >
              </p-dropdown>
            </div>

            <div class="column is-12 form-container">
              <label class="label">Observaciones</label>
              <textarea
                class="search-input observations-field"
                pInputTextarea
                [autoResize]="true"
                formControlName="observations"
                rows="3"
                maxlength="2000"
              ></textarea>
            </div>

            <div class="column is-12 form-container">
              <div class="field">
                <p-checkbox
                  formControlName="hasAccess"
                  [binary]="true"
                  inputId="hasAccess"
                >
                </p-checkbox>
                <label
                  for="hasAccess"
                  style="margin-left: 0.5rem; cursor: pointer"
                  >Usuario con acceso</label
                >
              </div>
            </div>

            <ng-container *ngIf="userForm.get('hasAccess')?.value">
              <div class="column is-12 form-container">
                <span class="label">Acceso a</span>
                <p-multiSelect
                  [options]="accessToOptions"
                  formControlName="accessTo"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Seleccionar"
                  [showClear]="true"
                  appendTo="body"
                >
                </p-multiSelect>
              </div>

              <div
                class="column is-12 form-container"
                *ngIf="
                  userForm.get('accessTo')?.value?.includes('impuestos_laboral')
                "
              >
                <span class="label">Modelos laborales</span>
                <p-multiSelect
                  [options]="laborModelsOptions"
                  formControlName="laborModelsAccess"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Seleccionar modelos laborales"
                  [showClear]="true"
                  appendTo="body"
                >
                </p-multiSelect>
              </div>

              <div
                class="column is-12 form-container"
                *ngIf="
                  userForm.get('accessTo')?.value?.includes('impuestos_fiscal')
                "
              >
                <span class="label">Modelos fiscales y contables</span>
                <p-multiSelect
                  [options]="fiscalModelsOptions"
                  formControlName="fiscalModelsAccess"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Seleccionar modelos fiscales y contables"
                  [showClear]="true"
                  appendTo="body"
                >
                </p-multiSelect>
              </div>

              <div class="column is-12 form-container">
                <div class="field">
                  <p-checkbox
                    formControlName="accessToCircularLetters"
                    [binary]="true"
                    inputId="accessToCircularLetters"
                  >
                  </p-checkbox>
                  <label
                    for="accessToCircularLetters"
                    style="margin-left: 0.5rem; cursor: pointer"
                    >Acceso a circulares</label
                  >
                </div>
              </div>

              <ng-container
                *ngIf="userForm.get('accessToCircularLetters')?.value"
              >
                <div class="column is-12 form-container">
                  <span class="label">Correo electrónico</span>
                  <p-dropdown
                    [options]="availableEmails"
                    optionLabel="label"
                    optionValue="value"
                    formControlName="circularMail"
                    placeholder="Seleccionar correo electrónico"
                    [showClear]="true"
                    appendTo="body"
                    [emptyMessage]="'No hay correos disponibles'"
                  ></p-dropdown>
                </div>

                <div class="column is-12 form-container">
                  <span class="label">Grupos</span>
                  <p-multiSelect
                    [options]="groupAccessOptions"
                    formControlName="groupAccess"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Seleccionar grupos"
                    [showClear]="true"
                    appendTo="body"
                  >
                  </p-multiSelect>
                </div>

                <div class="column is-12 form-container">
                  <div class="field">
                    <p-checkbox
                      formControlName="newsletterAccess"
                      [binary]="true"
                      inputId="newsletterAccess"
                    >
                    </p-checkbox>
                    <label
                      for="newsletterAccess"
                      style="margin-left: 0.5rem; cursor: pointer"
                      >Newsletters</label
                    >
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </section>
        @if (submitError) {
          <p class="help is-danger" style="padding: 0 24px 12px;">{{ submitError }}</p>
        }
        <footer class="modal-card-foot buttons-container">
          <ng-container *ngIf="snapshotData; else userEditButtons">
            <button type="button" class="button cancel-button" (click)="closeUserModal()">Cerrar</button>
          </ng-container>
          <ng-template #userEditButtons>
            <button class="button cancel-button" (click)="closeUserModal()">
              Cancelar
            </button>
            <button
              class="button save-button"
              type="submit"
              [disabled]="!userForm.valid"
            >
              Guardar
            </button>
          </ng-template>
        </footer>
      </form>
    </div>
  </div>
  <div class="delete-modal" [class.is-active]="isDeleteUserModalVisible">
    <div class="delete-modal-background" (click)="closeDeleteUserModal()"></div>
    <div class="delete-modal-content">
      <h1 class="delete-modal-title">Eliminar usuario</h1>
      <div class="delete-modal-body">
        <div class="column is-12">
          <span> ¿Está seguro/a que desea eliminar el usuario? </span>
        </div>
        @if (submitError) {
          <p class="help is-danger" style="padding: 0 24px 12px;">{{ submitError }}</p>
        }
        <div class="delete-modal-buttons">
          <button
            class="button is-outlined cancel-button"
            (click)="closeDeleteUserModal()"
          >
            Cancelar
          </button>
          <button
            class="comment-button button is-pulled-right"
            (click)="confirmDeleteUser()"
          >
            Aceptar
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
